import script from "./Authenticator.vue?vue&type=script&setup=true&lang=js"
export * from "./Authenticator.vue?vue&type=script&setup=true&lang=js"

import "./Authenticator.vue?vue&type=style&index=0&id=80264090&scoped=true&lang=css"

import exportComponent from "/Users/matsunohiroshi/myact/smari/sumari-deliverybox/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-80264090"]])

export default __exports__